<template>
  <div class="campsites-container">
    <v-layout row wrap>
      <v-flex align-content-space-between
              md4
              xs12
              v-if="paymentTrue !== undefined && paymentTrue !== null && paymentTrue.length > 0"
              v-for="camp in paymentTrue"
              :key="camp.public_id">
        <v-container fluid class="pa-2">
          <v-card flat hover class="campsite-card">
            <!-- Image -->
            <div class="card-image-wrap" @click="openInfo(camp)">
              <v-img class="campsite-image"
                     :src="camp.thumbnail"
                     aspect-ratio="1.6"
                     gradient="to bottom, rgba(0,0,0,0.0), rgba(0,0,0,0.15)">
              </v-img>
              <div class="badge"
                   v-if="camp.pricing_status === 'true' && camp.price && camp.price[0]">
                From {{$localCurrency}} {{$roundOff(convert1(camp.price[0].currency_type, Math.min(camp.price[0].child_price, camp.price[0].adult_price)).amount)}}
              </div>
            </div>

            <!-- Body -->
            <div class="card-body">
              <div class="title-row">
                <h3 class="card-title" @click="openInfo(camp)">
                  {{ (camp.name).toUpperCase() }}
                </h3>
                <button class="info-btn" @click="openInfo(camp)" aria-label="More info">
                  <v-icon small color="#3f632b">mdi-information-outline</v-icon>
                </button>
              </div>

              <!-- Capacity -->
              <div class="card-meta">
                <v-icon x-small color="#7b8f6b">mdi-account-group</v-icon>
                <span>
                  Max {{ camp.maximum_guests || 10 }} guests
                  <template v-if="camp.quantity"> · {{ camp.quantity }} units</template>
                </span>
              </div>

              <!-- Pricing -->
              <div class="card-pricing" v-if="camp.pricing_status === 'true' && camp.price && camp.price[0]">
                <div class="price-row">
                  <span>Child</span>
                  <span class="price-value">
                    {{$localCurrency}} {{$roundOff(convert1(camp.price[0].currency_type, camp.price[0].child_price).amount)}}
                  </span>
                </div>
                <div class="price-row">
                  <span>Adult</span>
                  <span class="price-value">
                    {{$localCurrency}} {{$roundOff(convert1(camp.price[0].currency_type, camp.price[0].adult_price).amount)}}
                  </span>
                </div>
              </div>
              <div class="card-pricing" v-else-if="camp.pricing">
                <div class="price-row">
                  <span>{{ camp.pricing }}</span>
                </div>
              </div>
            </div>
          </v-card>
        </v-container>
      </v-flex>
    </v-layout>

    <!-- Skeleton -->
    <v-layout row wrap v-if="paymentTrue === undefined || paymentTrue === null || paymentTrue.length === 0">
      <v-flex lg4 md12 xs12 sm12 v-for="n in 3" :key="n">
        <v-container fluid class="pa-2">
          <v-card class="campsite-card">
            <v-container>
              <content-placeholders :rounded="true">
                <content-placeholders-img />
                <content-placeholders-heading />
              </content-placeholders>
            </v-container>
          </v-card>
        </v-container>
      </v-flex>
    </v-layout>

    <!-- Info Dialog (unchanged) -->
    <v-dialog v-model="infoDialog" persistent max-width="900px">
      <v-card class="info-dialog">
        <div class="gallery-section">
          <div v-if="infoImages && infoImages.length > 0" class="gallery-container">
            <div class="image-navigation">
              <button class="nav-button prev" @click="prevInfoImage" :disabled="currentInfoImageIndex === 0">
                <v-icon>chevron_left</v-icon>
              </button>
              <div class="image-wrapper">
                <img :src="infoImages[currentInfoImageIndex].path" class="gallery-image" alt="Facility image">
              </div>
              <button class="nav-button next" @click="nextInfoImage" :disabled="currentInfoImageIndex === infoImages.length - 1">
                <v-icon>chevron_right</v-icon>
              </button>
            </div>
            <div class="image-counter">
              {{ currentInfoImageIndex + 1 }} / {{ infoImages.length }}
            </div>
          </div>
          <div v-else class="single-image-container">
            <img :src="currentInfoCamp ? currentInfoCamp.thumbnail : ''" class="gallery-image" alt="Facility thumbnail">
          </div>
        </div>

        <v-card-text class="details-section">
          <div class="details-header">
            <h1 class="facility-title earthwerk-font">{{ currentInfoCamp ? currentInfoCamp.name.toUpperCase() : '' }}</h1>
            <div class="capacity-display">
              <div class="capacity-item">
                <v-icon small color="grey">people</v-icon>
                <span class="capacity-label">Maximum Capacity:</span>
                <span class="capacity-value">{{ currentInfoCamp ? currentInfoCamp.maximum_guests : '' }} Guests</span>
              </div>
            </div>
          </div>
          <div class="description-section" v-html="currentInfoCamp ? currentInfoCamp.description : ''"></div>

          <div v-if="currentInfoCamp && currentInfoCamp.pricing_status === 'true'" class="pricing-section">
            <h3 class="earthwerk-font">Pricing Information</h3>
            <div class="price-info-dialog">
              <div class="price-pack">
                <span>Child Rate: </span>
                <span>{{$localCurrency}} {{$roundOff(convert1(currentInfoCamp.price[0].currency_type, currentInfoCamp.price[0].child_price).amount)}} per night</span>
              </div>
              <div class="price-pack">
                <span>Adult Rate: </span>
                <span>{{$localCurrency}} {{$roundOff(convert1(currentInfoCamp.price[0].currency_type, currentInfoCamp.price[0].adult_price).amount)}} per night</span>
              </div>
            </div>
          </div>
        </v-card-text>

        <v-card-actions class="dialog-actions">
          <v-spacer></v-spacer>
          <v-btn flat @click="infoDialog = false" class="earthwerk-font">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  export default {
    name: 'camp-sites',
    data() {
      return {
        infoDialog: false,
        currentInfoCamp: null,
        currentInfoImageIndex: 0,
        infoImages: []
      }
    },
    created() {
      this.$store.dispatch('get_active_camping')
    },
    methods: {
      facilityImage: function (image) {
        return 'http://178.79.164.219:8000/var/www/html/opc_services/' + image
      },

      openInfo(camp) {
        this.currentInfoCamp = camp
        this.currentInfoImageIndex = 0
        this.infoDialog = true

        if (this.$store.dispatch && this.$store._actions && this.$store._actions['get_facility_images']) {
          this.$store.dispatch('get_facility_images', camp.public_id).then(() => {
            if (this.$store.state.FacilityStore && this.$store.state.FacilityStore.facility_images) {
              this.infoImages = this.$store.state.FacilityStore.facility_images
            }
          }).catch(() => {
            this.infoImages = []
          })
        }
      },

      prevInfoImage() {
        if (this.currentInfoImageIndex > 0) {
          this.currentInfoImageIndex--
        }
      },

      nextInfoImage() {
        if (this.currentInfoImageIndex < this.infoImages.length - 1) {
          this.currentInfoImageIndex++
        }
      }
    },
    computed: {
      paymentTrue: function () {
        var activeInventory = []
        if (this.allCampsites && Array.isArray(this.allCampsites)) {
          this.allCampsites.map(function (data) {
            if (data.pricing_status === 'true' && data.thumbnail !== null) {
              activeInventory.push(data)
            }
          })
        }
        return activeInventory
      }
    }
  }
</script>

<style scoped>
  @font-face {
    font-family: 'Earthwerk';
    src: url('../PizzaDude.dk-Earthwerk.otf');
    font-weight: normal;
    font-style: normal;
  }

  .campsites-container {
    max-width: 1200px;
    margin: 0 auto;
    position: relative;
  }

  /* ---------- CARD ---------- */
  .campsite-card {
    background: rgba(255, 255, 255, 0.96) !important;
    border-radius: 18px !important;
    overflow: hidden;
    border: 1px solid rgba(165, 214, 167, 0.4);
    box-shadow: 0 6px 18px -8px rgba(0, 0, 0, 0.25) !important;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
  }
  .campsite-card:hover {
    transform: translateY(-3px);
    box-shadow: 0 12px 26px -10px rgba(0, 0, 0, 0.3) !important;
  }

  .card-image-wrap {
    position: relative;
    width: 100%;
    cursor: pointer;
    overflow: hidden;
  }
  .campsite-image {
    border-radius: 0 !important;
    display: block;
    transition: transform 0.4s ease;
  }
  .campsite-card:hover .campsite-image {
    transform: scale(1.04);
  }

  .badge {
    position: absolute;
    top: 12px;
    left: 12px;
    background: #8cc63f;
    color: #ffffff;
    font-size: 12px;
    font-weight: 700;
    padding: 5px 12px;
    border-radius: 16px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
    letter-spacing: 0.2px;
  }

  .card-body {
    padding: 14px 16px 16px;
  }

  .title-row {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 10px;
  }

  .card-title {
    flex: 1;
    margin: 0;
    font-family: 'Earthwerk', sans-serif;
    font-size: 15px;
    line-height: 1.25;
    font-weight: 700;
    color: #2d4a1e;
    letter-spacing: 0.4px;
    cursor: pointer;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    transition: color 0.15s ease;
  }
  .card-title:hover {
    color: #74a533;
  }

  .info-btn {
    flex-shrink: 0;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background: #eef3e8;
    border: none;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    transition: background 0.15s ease;
  }
  .info-btn:hover {
    background: #dbe8cc;
  }

  .card-meta {
    display: flex;
    align-items: center;
    gap: 4px;
    margin-top: 6px;
    font-size: 11.5px;
    color: #7b8f6b;
  }

  .card-pricing {
    margin-top: 10px;
    padding-top: 8px;
    border-top: 1px solid #eef1ea;
  }

  .price-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 12.5px;
    color: #5e6e4e;
    padding: 2px 0;
    gap: 8px;
  }
  .price-row > span:first-child {
    flex: 1;
  }
  .price-value {
    font-weight: 700;
    color: #e67e22;
    white-space: nowrap;
  }

  /* Keep the earthwerk-font class for the dialog title (unchanged) */
  .earthwerk-font {
    font-family: 'Earthwerk', sans-serif;
    color: #333;
    font-size: 20px;
    line-height: 1.3;
    margin-bottom: 8px;
    letter-spacing: 0.5px;
  }

  /* ============ INFO DIALOG (unchanged) ============ */
  .info-dialog {
    border-radius: 12px !important;
    overflow: hidden;
  }

  .gallery-section {
    width: 100%;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    position: relative;
  }

  .gallery-container, .single-image-container {
    width: 100%;
    height: 400px;
  }

  .image-navigation {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 100%;
    position: relative;
  }

  .image-wrapper {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .gallery-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  .nav-button {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    background: rgba(255, 255, 255, 0.7);
    border: none;
    border-radius: 50%;
    width: 50px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 10;
    transition: all 0.3s ease;
  }
  .nav-button:hover { background: rgba(255, 255, 255, 0.9); }
  .nav-button:disabled { opacity: 0.5; cursor: not-allowed; }
  .nav-button.prev { left: 20px; }
  .nav-button.next { right: 20px; }

  .image-counter {
    position: absolute;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
    background: rgba(0, 0, 0, 0.6);
    color: white;
    padding: 5px 15px;
    border-radius: 20px;
    font-size: 14px;
    z-index: 10;
  }

  .details-section {
    background: white;
    border-radius: 12px;
    padding: 30px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }

  .details-header {
    margin-bottom: 25px;
    border-bottom: 1px solid #eee;
    padding-bottom: 20px;
  }

  .facility-title {
    font-family: 'Earthwerk', sans-serif;
    color: #333;
    font-size: 32px;
    margin-bottom: 15px;
    letter-spacing: 0.5px;
  }

  .description-section {
    color: #555;
    line-height: 1.8;
    font-size: 16px;
    margin-bottom: 30px;
  }

  .capacity-display {
    display: flex;
    gap: 20px;
    margin-top: 15px;
    flex-wrap: wrap;
  }

  .capacity-item {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .capacity-label {
    font-size: 14px;
    color: #666;
  }

  .capacity-value {
    font-size: 16px;
    font-weight: 600;
    color: #74a533;
  }

  .pricing-section {
    margin-top: 20px;
    padding-top: 20px;
    border-top: 1px solid #eee;
  }
  .pricing-section h3 {
    margin-bottom: 15px;
    color: #74a533;
  }

  .price-info-dialog {
    color: #666;
    font-size: 16px;
  }
  .price-info-dialog .price-pack {
    margin-bottom: 10px;
  }

  .dialog-actions {
    padding: 16px 24px;
    border-top: 1px solid #eee;
  }

  /* ---------- RESPONSIVE ---------- */
  @media (max-width: 960px) {
    .earthwerk-font { font-size: 18px; }
    .gallery-container, .single-image-container { height: 300px; }
    .facility-title { font-size: 28px; }
    .card-title { font-size: 14.5px; }
  }

  @media (max-width: 600px) {
    .campsite-card { margin-bottom: 8px; }
    .earthwerk-font { font-size: 16px; }
    .card-body { padding: 12px 14px 14px; }
    .card-title { font-size: 14px; }
    .badge { font-size: 11px; padding: 4px 10px; top: 10px; left: 10px; }
    .price-row { font-size: 12px; }

    .gallery-container, .single-image-container { height: 250px; }
    .facility-title { font-size: 24px; }
    .nav-button { width: 35px; height: 35px; }
    .nav-button.prev { left: 10px; }
    .nav-button.next { right: 10px; }
    .image-counter { font-size: 12px; padding: 3px 10px; }
    .capacity-display { flex-direction: column; gap: 10px; }
  }
</style>